import React from "react";
import { Text } from "@chakra-ui/react";
export const PageTitle = ({ children }) => /* @__PURE__ */ React.createElement(Text, { color: "ionDark", textStyle: "heading-3" }, children);
